export default __webpack_public_path__ + "static/train-accidents-a60770c530baec5401f726692fb14d9e.jpg";